import useAxios, { Options, UseAxiosResult } from "axios-hooks";
import * as config  from "../config";
import useSessionStorage from "@/hooks/useSessionStorage";
import useAuth from "@/hooks/useAuth";
import Axios, { AxiosResponse } from "axios";

const apiClient = Axios.create()



export const useUsers = (url: string, options = {})=>{
    return useAxios("/admin/users", options)
}

export interface User {
    id: string,
    email: string,
    firstName: string,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    isLocked: boolean,
    isActive: boolean,
    isReady: boolean,
    answer: {
        id: string,
        userId: string,
        data: {
            survey: {
                personalInformation: {
                    firstName: string,
                    lastName: string,
                    zipcode: string,
                    gender: string,
                    ethnicity: string,
                    lannguages: string[]
                    leadership: number,
                    organizations:{
                        name: string,
                        dates: string[]
                    }[]
                    stateRegional: boolean,
                    mother: string[],
                    father: string[]
                },
                academics: {
                    name: string,
                    city: string,
                    state: string,
                    grade: number,
                    graduationYear: number,
                    gpa: string,
                    classRank: number,
                    apExams: {
                        subject: string,
                        score: number,
                    },
                    curriculumDifficulty: number,
                    act: string,
                    testType: string
                }
            },
            favorites: {
                id: string,
                name: string,
                address?: string,
                city: string,
                state: string,
                zipcode: string,
                phoneNumber?: string,
                website?: string,
                universityId?: string,
                keep?: boolean,
                behzadColumn?: string,
                active: boolean,
                createdAt: string,
                updatedAt?: string,
                unitId: string,
                verbal25: string,
                verbal75: string,
                math25: string,
                math75: string,
                admissionRate: string,
                rank: string,
                avgSat: string,
                avgAct: string,
                act25: string,
                act75: string,
                homePage?: string,
                applicationPage?: string,
                financialAidPage?: string,
                historicAdmissionsRate: string,
                historicMath25: number,
                historicMath75: number,
                historicVerbal25: number,
                historicVerbal75: number,
                isLegacy: boolean
            }[]
        },
        createdAt: string,
        updatedAt: string,
        initialQuestions?: string,
        personalInformation: string,
        academics?: string,
        version: number
    },
    authentications: {
        id: number,
        email: string,
        success: boolean,
        ipaddress: string,
        createdAt: string,
        updatedAt: string,
        userId: number
    }[]
}

export const useUsersRequest = ()=>{
    const {user} = useAuth()
    
    const token = user?.token

    let url = undefined;
    let headers = undefined
    console.log("token", token)
    if(token){
        url = `${config.apiConfig.host}/admin/users`
        headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`,
        }
    }
    console.log("url", url)
    return useAxios<User[]>({
        url,
        headers 
    })
}

// export const useUserSignupsRequest = ()=>{
//     const {user} = useAuth()
    
//     const token = user?.token

//     let url;
//     const headers = {
//         "Content-Type": "application/json",
//         "Accept": "application/json",
//         "Authorization": `Bearer ${token}`,
//     }
//     if(token){
//         url = `${config.apiConfig.host}/admin/users`
//     }
//     return useAxios<User[]>({
//         url,
//         headers 
//     })
// }


export const useUserInviteRequest = () => {
    const {user} = useAuth()
    
    const token = user?.token

    return useAxios(
        {
            url: `${config.apiConfig.host}/admin/invitations`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": `Bearer ${token}`,
            },
        },
        { manual: true }
    );
}

interface FullUser {
    id: string,
    email: string,
    firstName: string,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    isLocked: boolean,
    isReady: boolean,
    isActive: boolean,
    answer: {
        id: string,
        userId: string,
        data: {
            survey: {
                personalInformation: {
                    firstName: string,
                    lastName: string,
                    zipcode: string,
                    gender: string,
                    ethnicity: string,
                    languages: string[],
                    leadership: number,
                    localOrganizations: boolean,
                    nationalOrganizations: boolean,
                    organizationAwards: boolean,
                    schoolAwards: boolean,
                    stateRegional: boolean,
                    mother: {id: string, name: string}[],
                    father: {id: string, name: string}[]
                },
                academics: {
                    name: string,
                    city: string,
                    state: string,
                    grade: number,
                    graduationYear: number,
                    gpa: string,
                    classRank: number,
                    satHighestLanguageScore: string,
                    satHighestMathScore: string,
                    apExams: {subject: string, score: number}[],
                    curriculumDifficulty: number,
                    testType: string
                }
            },
            favorites: {
                id: string,
                name: string,
                address: null,
                city: string,
                state: string,
                zipcode: string,
                phoneNumber: string,
                website: string,
                universityId: string,
                keep: boolean,
                behzadColumn: string,
                active: boolean,
                createdAt?: string,
                updatedAt?: string,
                unitId: string,
                verbal25: string,
                verbal75: string,
                math25: string,
                math75: string,
                admissionRate: string,
                rank: string,
                avgSat: string,
                avgAct: string,
                act25: string,
                act75: string,
                homePage?: string,
                applicationPage?: string,
                financialAidPage?: string,
                historicAdmissionsRate: string,
                historicMath25: number,
                historicMath75: number,
                historicVerbal25: number,
                historicVerbal75: number,
                isLegacy: boolean
            }[]
        },
        createdAt: string,
        updatedAt: string,
        initialQuestions?: string,
        personalInformation?: string,
        academics?: string,
        version: number
    },
    authentications: [],
    scores: {
            testData: {
                id: string,
                sat_math_25: number,
                sat_math_75: number,
                sat_read_25: number,
                sat_read_75: number
            },
            admitRateData: {
                id: string,
                Percent_of_applicants_admitted: string
            },
            university: {
                id: string,
                name: string,
                address?: string,
                city: string,
                state: string,
                zipcode: string,
                phoneNumber?: string,
                website?: string,
                universityId?: string,
                keep?: boolean,
                behzadColumn: boolean,
                active: boolean,
                createdAt: string,
                updatedAt: string,
                unitId: string,
                verbal25: string,
                verbal75: string,
                math25: string,
                math75: string,
                admissionRate: string,
                rank: string,
                avgSat: string,
                avgAct: string,
                act25: string,
                act75: string,
                homePage?: string,
                applicationPage?: string,
                financialAidPage?: string,
                historicAdmissionsRate: string,
                historicMath25: number,
                historicMath75: number,
                historicVerbal25: number,
                historicVerbal75: number,
                isLegacy: boolean
            },
            id: string,
            score: number,
            name: string,
            state: string,
            formula:string
    }[]
}
export const useUserDetailsRequest = (id?: string) => {
    const {user} = useAuth()
    
    const token = user?.token
    
    let url
    if(token && id){
        console.log("id", id)
        url= `${config.apiConfig.host}/admin/scores/${id}`
        console.log(url)
    }

    return useAxios<FullUser>(
        {
            url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": `Bearer ${token}`,
            },
        }
    );
}

type Params = {userId: string, isLocked: boolean}
export const useUserUpdateRequest = ():[
    undefined,
    (params: Params) => Promise<AxiosResponse<any>>,
    undefined
  ] => {
    const {user} = useAuth()
    
    
    const mutate = ({userId, isLocked}:Params)=>{
        const token = user?.token
    
        if (!token) {
            throw new Error("No token found");
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": `Bearer ${token}`,
        }
        
        return apiClient.put(`${config.apiConfig.host}/admin/users/${userId}`,
            {
                isLocked
            },
            {headers}
        )
    }

    return [undefined, mutate, undefined]
}

type InviteParams = {
    userId: string,
}

export const useSendUserInviteRequest = ():[
    undefined,
    (params: InviteParams) => Promise<AxiosResponse<any>>,
    undefined
  ] => {
    const {user} = useAuth()
    
    
    const mutate = ({userId}:InviteParams)=>{
        const token = user?.token
    
        if (!token) {
            throw new Error("No token found");
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": `Bearer ${token}`,
        }
        
        return apiClient.post(`${config.apiConfig.host}/admin/invitations/${userId}/send`,
            {},
            {headers}
        )
    }

    return [undefined, mutate, undefined]
}


// Add function like useUserSignupsRequest to test an invitation code
// /users/verify-invitation url

// Verify an invitation code against the invited email. This is a public,
// on-demand check (the student types the code), so it is a plain callable
// request rather than an on-mount hook, and it sends no auth token.
export const verifyInvitationRequest = (email: string, invitationCode: string) => {
    return apiClient.post<{valid: boolean; error?: string}>(
        `${config.apiConfig.host}/users/invitations/verify`,
        { email, invitationCode },
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        }
    );
}

// A signup request that hits the local api
// A signup request that hits the local api
export const useUserSignupsRequest = ():[undefined, (data: {email: string, password: string, invitationCode?: string}) => Promise<AxiosResponse<any>>, undefined] => {
    const {user} = useAuth()
    const token = user?.token

    const mutate = async (data: {email: string, password: string, invitationCode?: string}) => {
        const token = user?.token

        if (!token) {
            throw new Error("No token found");
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": `Bearer ${token}`,
        }

        return apiClient.post(`${config.apiConfig.host}/users/signups`,
            {
                ...data
            },
            {headers}
        )
    }

    return [undefined, mutate, undefined]
}